module.exports = "<div (click)=\"handleClick($event)\" [ngClass]=\"{disabled: disabled || !_currentEditor }\" class=\"toolbar\">\n  <ng-content></ng-content>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/wysihtml-toolbar.component.html
// module id = 9
// module chunks = 0